export default __webpack_public_path__ + "static/media/info-emergencia-medica.eab4869a.svg";